<template>
  <button
    class="primary-button"
    :disabled="disabled"
    v-bind="$attrs"
    @click="$emit('click')"
  >
    <slot />

    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="24" width="2"></v-progress-circular>
    </v-overlay>
  </button>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss">
$primary: #1b559e;

.primary-button {
  background: $primary;
  color: white;

  border-radius: 8px;

  padding: 16px 8px;

  font-family: Roboto;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;

  position: relative;

  &:hover {
    background: darken($primary, 5%);
  }

  &:disabled {
    background-color: gray;
    cursor: not-allowed;
  }
}
</style>
